"use client";

import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FinalConversionCTA() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: captionRef,
    isVisible: captionVisible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  return <section data-section-id="4086" id="finalconversioncta" className="bg-background text-foreground py-24 md:py-36 px-4 sm:px-6 md:px-12 lg:px-20 !bg-[url(https://phoenixlimo.info/wp-content/uploads/2026/06/2-scaled.jpg)]">
      <div className="relative mx-auto max-w-7xl rounded-lg overflow-visible" style={{
      background: "linear-gradient(135deg, hsl(26 100% 50%) 0%, hsl(26 100% 40%) 100%)"
    }}>
        
      </div>
    </section>;
}